import { render, staticRenderFns } from "./ModalSetDomain.vue?vue&type=template&id=1ce88966"
import script from "./ModalSetDomain.vue?vue&type=script&lang=js"
export * from "./ModalSetDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports